import { useEffect, useContext } from "react";
import axios from "axios";
import { UserIPLocation } from "../Layout";

const IPLocationDetector = () => {
  const { setUserIPLocation, setUserIPLocationCode } = useContext(UserIPLocation);

  useEffect(() => {
    axios
      .get("https://asia-southeast1-tdcx-v2.cloudfunctions.net/function-1")
      .then(response => {
        switch (response.data.country) {
          case "SG":
            setUserIPLocation("Singapore");
            setUserIPLocationCode("SG");
            break;
          case "MY":
            setUserIPLocation("Malaysia");
            setUserIPLocationCode("MY");
            break;
          case "TH":
            setUserIPLocation("Thailand");
            setUserIPLocationCode("TH");
            break;
          case "PH":
            setUserIPLocation("Philippines");
            setUserIPLocationCode("PH");
            break;
          case "HK":
            setUserIPLocation("Hong Kong");
            setUserIPLocationCode("HK");
            break;
          case "CN":
            setUserIPLocation("China");
            setUserIPLocationCode("CN");
            break;
          case "JP":
            setUserIPLocation("Japan");
            setUserIPLocationCode("JP");
            break;
          case "ES":
            setUserIPLocation("Spain");
            setUserIPLocationCode("ES");
            break;
          case null:
          case undefined:
          default:
            setUserIPLocation("Singapore");
            setUserIPLocationCode("SG");
            break;
        }
      })
      .catch(error => {
        setUserIPLocation("Singapore");
        setUserIPLocationCode("SG");
        if (process.env.GATSBY_ACTIVE_ENV !== "production") {
          console.log(error);
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default IPLocationDetector;
